import { createShipmentCreationSlice } from '@/modules/shipment-creation/createShipmentSlice';
import { INBOUND_CONFIG } from '@/modules/shipment-creation/configs';

const inbound = createShipmentCreationSlice(INBOUND_CONFIG);

export const inboundSliceActions = inbound.actions;
export const inboundSliceSelectors = inbound.selectors;

export const {
  setStep,
  goToNextStep,
  goToPreviousStep,
  updateBasicDetails,
  updateParty,
  clearParty,
  updateCargo,
  triggerValidation,
  hideValidation,
  resetForm,
  loadDraftData,
  setSyncStatus,
  setShipmentId,
  setSyncError,
  clearSyncState,
} = inbound.actions;

export const selectCreateInbound = inbound.selectors.selectRoot;
export const selectCurrentStep = inbound.selectors.selectCurrentStep;
export const selectFormData = inbound.selectors.selectFormData;
export const selectBasicDetails = inbound.selectors.selectBasicDetails;
export const selectCargo = inbound.selectors.selectCargo;
export const selectValidation = inbound.selectors.selectValidation;
export const selectShowErrors = inbound.selectors.selectShowErrors;
export const selectSync = inbound.selectors.selectSync;
export const selectIsDirty = inbound.selectors.selectIsDirty;
export const selectShipmentId = inbound.selectors.selectShipmentId;

export type { ShipmentCreationStep as CreateInboundStep } from '@/modules/shipment-creation/types';
export type { ShipmentParty as InboundParty } from '@/modules/shipment-creation/types';
export type { ShipmentOrganizationLocation as InboundOrganizationLocation } from '@/modules/shipment-creation/types';
export type { ShipmentBasicDetailsData as InboundBasicDetailsData } from '@/modules/shipment-creation/types';
export type { ShipmentCargoStepData as InboundCargoStepData } from '@/modules/shipment-creation/types';
export type { ShipmentCreationFormData as CreateInboundFormData } from '@/modules/shipment-creation/types';
export type { ShipmentSyncStatus as InboundSyncStatus } from '@/modules/shipment-creation/types';
export type { ShipmentSyncState as InboundSyncState } from '@/modules/shipment-creation/types';
export type { ShipmentPartyType as InboundPartyType } from '@/modules/shipment-creation/types';
export type { ValidationErrors } from '@/modules/shipment-creation/types';
export type { ShipmentCreationState as CreateInboundState } from '@/modules/shipment-creation/types';

export default inbound.reducer;
